import React, { useState } from "react";
import "./Sort_by_Modal.css";
import { Modal, Form } from "react-bootstrap";

function Sort_by_Modal({ selectedOption, setSelectedOption, ...props }) {
  // const [selectedOption, setSelectedOption] = useState("Default");

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  console.log(selectedOption, " selectedOption,selectedOption selectedOption");

  return (
    <>
      <section className="Sort_by_Modal modal-holder">
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="Sort_by_Modal modal-holder"
        >
          <Modal.Header className="common_modal_header">
            <Modal.Title>Sort by</Modal.Title>
            <div className="right_side_close_modal_btn">
              <img
                src="/assets/Image/Icon/close.png"
                className="close_modal_img"
                onClick={() => {
                  props?.onHide();
                }}
              />
            </div>
          </Modal.Header>
          <Modal.Body>
            <Form className="form-holder">
              <Form.Group>
                <div className="radio-btn-text-holder">
                  <p className={selectedOption === "Default" ? "active" : ""}>
                    Default
                  </p>
                  <Form.Check
                    type="radio"
                    name="sortOptions"
                    value=""
                    checked={selectedOption === ""}
                    onChange={handleOptionChange}
                  />
                </div>

                <div className="radio-btn-text-holder">
                  <p
                    className={
                      selectedOption === "PriceHighToLow" ? "active" : ""
                    }
                  >
                    Price - High to Low
                  </p>
                  <Form.Check
                    type="radio"
                    name="sortOptions"
                    value="DESC"
                    checked={selectedOption === "DESC"}
                    onChange={handleOptionChange}
                  />
                </div>

                <div className="radio-btn-text-holder">
                  <p
                    className={
                      selectedOption === "PriceLowToHigh" ? "active" : ""
                    }
                  >
                    Price - Low to High
                  </p>
                  <Form.Check
                    type="radio"
                    name="sortOptions"
                    value="ASC"
                    checked={selectedOption === "ASC"}
                    onChange={handleOptionChange}
                  />
                </div>

                {/* <div className="radio-btn-text-holder">
                  <p
                    className={
                      selectedOption === "DiscountHighToLow" ? "active" : ""
                    }
                  >
                    Discount - High to Low
                  </p>
                  <Form.Check
                    type="radio"
                    name="sortOptions"
                    value="DiscountHighToLow"
                    checked={selectedOption === "DESC"}
                    onChange={handleOptionChange}
                  />
                </div> */}
              </Form.Group>
            </Form>
          </Modal.Body>
        </Modal>
      </section>
    </>
  );
}

export default Sort_by_Modal;
